module.exports = __webpack_public_path__ + "static/media/background.81c0b95e.png";